export const API_URL = 'https://jomlaline.net/api'; // Update with your backend URL
